import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function generateMblNo(configName, identificationCode, data) {
  return request({
    url: `${URL.seaExport.generateMblNo}?configName=${configName}&identificationCode=${identificationCode}`,
    method: 'post',
    data
  })
}
export function generateSoNo(params) {
  return request({
    url: URL.seaExport.generateSoNo,
    method: 'post',
    params
  })
}
export function allocateSoNo(jobUuid) {
  return request({
    url: `${URL.seaExport.allocateSoNo}?jobUuid=${jobUuid}`,
    method: 'get'
  })
}
